module.exports = __webpack_public_path__ + "057c4d582c7953542fd93af49aaaeaea.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/videos/SpeechGuardOFF.mp4
// module id = 400
// module chunks = 0